import { render, staticRenderFns } from "./BaseStoreFileList.vue?vue&type=template&id=06f4d584&scoped=true"
import script from "./BaseStoreFileList.vue?vue&type=script&lang=js"
export * from "./BaseStoreFileList.vue?vue&type=script&lang=js"
import style0 from "./BaseStoreFileList.vue?vue&type=style&index=0&id=06f4d584&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f4d584",
  null
  
)

export default component.exports